import { PerformanceDatapoint } from 'owa-analytics';
import { type TableQueryType } from 'owa-mail-list-store';
import type { MailFolderTableQuery, TableView } from 'owa-mail-list-store';
import type { ActionSource } from 'owa-mail-store';
import {
    getMailListLoadDatapointContext,
    isMailListLoadGenerationEnabled,
    setMailListLoadDatapoint,
} from './mailListLoadDatapointGetterAndSetter';
import endMailListLoadDatapoint from './endMailListLoadDatapoint';
import { getMailboxInfo } from 'owa-mail-mailboxinfo';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';

let eventTimestamp: number | undefined = undefined;

export function setInteractionTimestamp(timeStamp?: number): void {
    eventTimestamp = timeStamp;
}

export function createMailListLoadDatapoint(
    actionSource: ActionSource,
    tableView: TableView,
    owningSwitchMailFolderDatapoint?: PerformanceDatapoint
): number {
    // End the previous MLL datapoint if it did not complete before a new ML load.
    const currentContext = getMailListLoadDatapointContext();
    if (currentContext) {
        endMailListLoadDatapoint(
            'None' /*componentRendered*/,
            currentContext.tableViewId,
            currentContext.loadId,
            true /* shouldInvalidate */,
            undefined /* overrideStatus */,
            undefined /* error */
        );
    }

    const options = {
        timeout: 90 * 1000,
        eventTimestamp,
    };

    const mailboxInfo = getMailboxInfo(tableView);
    const mllDp = new PerformanceDatapoint('MailListLoad', mailboxInfo, options);
    const isFolderTable = tableView.tableQuery.type === 0;
    const folderTableQuery = isFolderTable
        ? (tableView.tableQuery as MailFolderTableQuery)
        : undefined;
    mllDp.addCustomData({
        act: actionSource,
        tq: tableView.tableQuery.type,
        lv: tableView.tableQuery.listViewType,
        fName: folderTableQuery ? folderIdToName(folderTableQuery.folderId) : undefined,
        scenario: folderTableQuery?.scenarioType,
        isCached: tableView.isInitialLoadComplete,
        atTop: tableView.loadedStartIndex === 0,
        hasSwitchOwner: !!owningSwitchMailFolderDatapoint,
        vis: window.document.visibilityState,
    });
    return setMailListLoadDatapoint(mllDp, tableView.id, owningSwitchMailFolderDatapoint);
}

export function invalidateMailListLoadForSwitch(
    abandonedSwitchMailFolderDatapoint: PerformanceDatapoint
): void {
    if (!isMailListLoadGenerationEnabled()) {
        return;
    }

    const currentContext = getMailListLoadDatapointContext();
    if (currentContext?.owningSwitchMailFolderDatapoint === abandonedSwitchMailFolderDatapoint) {
        endMailListLoadDatapoint(
            'None' /* componentRendered */,
            currentContext.tableViewId,
            currentContext.loadId,
            true /* shouldInvalidate */
        );
    }
}
